import React from 'react';

interface ReverseMappingConflictDialogProps {
    open: boolean;
    calendarName: string;
    conflictingTypeName: string;
    newTypeName: string;
    busy?: boolean;
    onCancel: () => void;
    onKeep: () => void;
    onOverwrite: () => void;
}

export const ReverseMappingConflictDialog: React.FC<ReverseMappingConflictDialogProps> = ({
    open, calendarName, conflictingTypeName, newTypeName, busy = false, onCancel, onKeep, onOverwrite,
}) => {
    if (!open) return null;

    return (
        <div
            onClick={busy ? undefined : onCancel}
            className="mapper-ui font-sans fixed inset-0 flex items-center justify-center z-[110] p-5"
            style={{ background: 'rgba(24,33,48,.42)' }}
        >
            <div
                onClick={e => e.stopPropagation()}
                className="bg-mapper-white rounded-2xl max-w-[540px] w-full overflow-hidden shadow-mapper-modal"
            >
                <div className="px-6 py-5 border-b border-mapper-border-3 flex items-center justify-between">
                    <h3 className="text-base font-bold m-0">This calendar is already connected both ways</h3>
                    <button onClick={onCancel} disabled={busy} className="w-[30px] h-[30px] rounded-lg text-mapper-muted-3 text-xl flex items-center justify-center">×</button>
                </div>

                <div className="px-6 py-[22px]">
                    <p className="text-sm text-mapper-body-text-3 leading-[1.6] m-0">
                        The <strong className="text-mapper-text">"{calendarName}"</strong> calendar already sends its
                        Ad Vital bookings back to your EMR as <strong className="text-mapper-text">"{conflictingTypeName}"</strong> appointments.
                    </p>
                </div>

                <div className="px-6 py-4 border-t border-mapper-border-3 flex flex-wrap items-center justify-end gap-3">
                    <button onClick={onCancel} disabled={busy} className="px-4 py-2 rounded-[9px] text-[13px] font-semibold text-mapper-muted">
                        Cancel
                    </button>
                    <button
                        onClick={onOverwrite}
                        disabled={busy}
                        className="px-4 py-2 rounded-[9px] text-[13px] font-bold border border-mapper-border-2 text-mapper-body-text disabled:opacity-60"
                    >
                        Override existing mapping
                    </button>
                    <button
                        onClick={onKeep}
                        disabled={busy}
                        className="px-5 py-2 rounded-[9px] text-[13px] font-bold bg-mapper-teal text-white shadow-mapper-btn disabled:opacity-60"
                    >
                        {busy ? 'Working…' : `Add "${newTypeName}" to "${calendarName}"`}
                    </button>
                </div>
            </div>
        </div>
    );
};
